import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import "./App.scss";
import { observer, inject } from "mobx-react";
import { Spin } from "antd";
import PrivateRoute from "./helpers/PrivateRoute";
import loader from "./assets2/img/logo-emblem.png"



const Reset = React.lazy(() => import("./views2/auth/Recover/Reset"));
const PreSaleReport = React.lazy(() => import("./views2/Management/Book/PreSaleReport"));
// Containers
const DefaultLayout = React.lazy(() => import("./views2/dashboard/DefaultLayout"));
// Pages
const Login = React.lazy(() => import("./views2/auth/Login/Login"));
const TwoFA = React.lazy(() => import("./views2/auth/Login/TwoFA/TwoFA"));
const LoginAs = React.lazy(() => import("./views2/auth/Login/LoginAs"));
const Request = React.lazy(() => import("./views2/auth/Recover/Recover"));
const PrivacyPolicy = React.lazy(() => import("./views2/PrivacyPolicy"));
const Book = React.lazy(() => import("./views2/Management/Book/Index"));
const MarketCheckReport = React.lazy(() => import("./views2/Management/Book/MarketCheckReport"));
const PharmacyActionReport = React.lazy(() => import("./views2/Management/Book/PharmacyActionReport"));
const PerformancePackageReport = React.lazy(() => import("./views2/Management/Book/PerformancePackageReport"));
const ExecutiveSummaryReport = React.lazy(() => import("./views2/Management/Book/ExecutiveSummary"));
const UpdatedPharmacyActionReport = React.lazy(() => import("./views2/Management/Book/UpdatedPharmacyActionReport"));
const SavingsReport = React.lazy(() => import("./views2/Management/Book/SavingsReport"));
const BobSavingsReport = React.lazy(() => import("./views2/Management/Book/BobSavingsReport"));
const AnaylsisProposalReport = React.lazy(() => import("./views2/Management/Book/AnalysisProposalReport"));
const MarketCheckPackageReport = React.lazy(() => import("./views2/Management/Book/MarketCheckPackageReport"));
const RebateManagementReport = React.lazy(() => import("./views2/Management/Book/RebateManagementReport"));
const MarketCheckPackageReportNew = React.lazy(() => import("./views2/Management/Book/MarketCheckPackageReportNew"));
const AnaylsisReportNew = React.lazy(() => import("./views2/Management/Book/AnalysisReport-New"));
const PharmacySavingsReport = React.lazy(() => import("./views2/Management/Book/PharmacySavingsReport"));
const Page404 = React.lazy(() => import("./views2/404"));
const UserDrafts = React.lazy(() => import("./views2/UserDrafts/UserDrafts"));


@inject("AuthStore")
@observer
class App extends Component {
  render() {
    console.log(this.props?.AuthStore?.user?.labeling);
    return (
      <Router>
        <React.Suspense fallback={
          this.props?.AuthStore?.user?.labeling?.slug != "" ? (
            <div className="text-center" style={{ marginTop: "350px" }}><Spin /></div>

          ) :
            <div className="animated fadeIn pt-3 text-center" style={{ marginTop: "350px" }}><img className="loading-spinner-initial" src={loader} /></div>
        }>

          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={props => <Login {...props} />}
            />
            <Route
              exact
              path="/user/drafts/:id"
              name="User Drafts"
              render={props => <UserDrafts {...props} />}
            />
            <Route
              exact
              path="/two_factor_authentication/:id"
              name="Two FA Page"
              render={props => <TwoFA {...props} />}
            />
            <Route
              exact
              path="/login/:slug"
              name="Login Page"
              render={props => <Login {...props} />}
            />
            <Route
              path="/privacy-policy"
              name="Privacy Policy"
              render={props => <PrivacyPolicy {...props} />}
            />
            <Route
              exact
              path="/login/:slug"
              name="Login Page"
              render={props => <Login {...props} />}
            />
            <Route
              exact
              path="/loginas/:jwt"
              name="Login Page"
              render={props => <LoginAs {...props} />}
            />
            <Route
              exact
              path="/recover"
              name="Recover Password"
              render={props => <Request {...props} />}
            />
            <Route
              exact
              path="/recover/:token"
              name="Recover Password"
              render={props => <Reset {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={props => <Page404 {...props} />}


            />
            <Route path='/books/:uuid' component={Book}></Route>
            <Route path='/market-check-report/:uuid' component={MarketCheckReport}></Route>
            <Route path='/pharmacy-action-report/:uuid' component={PharmacyActionReport}></Route>
            <Route path='/savings-report/:uuid' component={SavingsReport}></Route>
            <Route path='/pre-sale-report/:uuid' component={PreSaleReport}></Route>
            <Route path='/analysis-proposal-report/:uuid' component={AnaylsisProposalReport}></Route>
            <Route path='/performance-package-report/:uuid' component={PerformancePackageReport}></Route>
            <Route path='/executive-summary-report/:uuid' component={ExecutiveSummaryReport}></Route>
            <Route path='/updated-pharmacy-action/:uuid' component={UpdatedPharmacyActionReport}></Route>
            <Route path='/market-check-new/:uuid' component={MarketCheckPackageReportNew}></Route>
            <Route path='/bob-savings-report/:uuid' component={BobSavingsReport}></Route>
            <Route path='/analysis-proposal-report-new/:uuid' component={AnaylsisReportNew}></Route>
            <Route path='/market-check-package/:uuid' component={MarketCheckPackageReport}></Route>
            <Route path='/rebate-management-pdf-report/:uuid' component={RebateManagementReport}></Route>
            <Route path='/pharmacy-savings-report/:uuid' component={PharmacySavingsReport}></Route>

            <PrivateRoute path="/" name="Home" component={DefaultLayout} />
          </Switch>
        </React.Suspense>
      </Router >
    );
  }
}

export default App;
